import moment from 'moment'
import { lang } from 'helpers/translator/localize'

export default function dateFormat(date) {
	const dateArray = date.split('-')
	return dateArray[1]+'/'+dateArray[2]+'/'+dateArray[0]
}

export function dateFormatFromTimestamp(unixTmstmp, format='ddd, MMM Do YYYY') {
	moment.locale(lang)
	return moment(Number(unixTmstmp)*1000).format(format.toString())
}

export function dateFormatArrayFromTimestamp(unixTmstmp) {
	const date = new Date(unixTmstmp * 1000)
	return [date.getFullYear(), date.getMonth()+1, date.getDate()]
}

export function formatRemainingTime(startTimestamp, endTimestamp, actualTimestamp) {
	const timeDiff = Math.abs(endTimestamp - startTimestamp)
	const diffDays = Math.ceil(timeDiff / (3600 * 24))
	return milisecondsToTime(((startTimestamp) + diffDays * 86400) - actualTimestamp)
}

export function milisecondsToTime(inputMiliseconds) {
	const days = Math.floor(inputMiliseconds / 86400) // 86400 === seconds in a day

	if (days) {
		if (days > 1) {
			return days + ' days'
		}
		return days + ' day'
	}

	const hours = Math.floor(inputMiliseconds / 3600) // 3600 === seconds in an hour
	if (hours) {
		if (hours > 1) {
			return hours + ' hours'
		}
		return hours + ' hour'
	}
	return '< 1 hour'
}

export function dateFormatTimestampFromArray([year, month, day]) {
	return (new Date(year, month - 1, day)/1000)
}
